export default "__VITE_ASSET__8eaa106d__"